import type { EmailOrPhoneIdentity } from './types';

export function splitEmailOrPhone(value: string): EmailOrPhoneIdentity | null {
  const trimmed = (value || '').trim();
  if (/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(trimmed)) {
    return { email: trimmed, phone: null };
  }
  if (/^\+[1-9]\d{1,14}$/.test(trimmed)) {
    return { email: null, phone: trimmed };
  }
  return null;
}
